import { Component, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Subject } from 'rxjs';

interface ToggleOption {
  id: string;
  label: string;
  value: boolean;
  disabled?: boolean;
}
@Component({
  selector: 'app-slide-toggle-group',
  templateUrl: './slide-toggle-group.component.html',
  styleUrl: './slide-toggle-group.component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: SlideToggleGroupComponent
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: SlideToggleGroupComponent
    }
  ]
})
export class SlideToggleGroupComponent implements OnInit, ControlValueAccessor {
  @Input() title: string = 'Controls';
  @Input() options: ToggleOption[] = [];
  @Input() color: ThemePalette = 'primary';
  @Input() disableRipple: boolean = false;
  @Input() labelPosition: 'before' | 'after' = 'before';

  @Output() valueChanged = new Subject<{ id: string, value: boolean }>();

  touched = false;
  disabled = false;
  validationStatus: ValidationErrors | null;
  values: { [key: string]: boolean } = {};

  constructor() { }

  ngOnInit(): void {
    // Initialize values object with default values from options
    this.options.forEach(option => {
      this.values[option.id] = option.value;
    });
  }

  onChange: Function = Function;
  onTouched = () => { };

  writeValue(values: { [key: string]: boolean }) {
    if (values) {
      this.values = values;
    }
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    this.validationStatus = null;
    return this.validationStatus;
  }

  onToggleChange(event: MatSlideToggleChange, id: string) {
    this.values[id] = event.checked;
    this.valueChanged.next({ id, value: event.checked });
    this.onChange(this.values);
    this.markAsTouched();
  }

}
